export function createRoutes(routeJOSN, systemType) {
  let routes = []
  routeJOSN.forEach(route => {
    let children, router = {}
    if (route.node && route.node.length > 0) {
      children = createRoutes(route.node, route.systemType)
    }
    router['path'] = route.homePage || '/test'
    // console.log(route.resIcon)
    router.icon = route.resIcon
    router.name = route.resCode
    router.nameCn = route.resNameCn||""
    router.type = route.resType
    if (router.type == "MODULE") {
      router.regx = "^" + router.path
    }
    router.meta = {
      systemType: route.systemType || systemType
    }
    if (children) {
      router['children'] = children
    }
    routes.push(router)
  })
  return routes;
}

export function createRoutesBySystem(routes) {
  let systemList = {}, res = []
  routes.forEach(v => {
    let systemType = v.meta.systemType, system = {}
    if (!systemList[systemType]) {
      // systemList[systemType]={}
      system['name'] = systemType
      system['children'] = []
      system['children'].push(v)
      systemList[systemType] = system
    }
    else {
      systemList[systemType].children.push(v)
    }
    // systemList[systemType] = system
  })
  for (const key in systemList) {
    if (Object.hasOwnProperty.call(systemList, key)&&key!=='BASE_SERVER') {
      const item = systemList[key];
      res.push(item)
    }
  }
  return res
}

export function findModuleByRoute(path) {
  // console.log(path)
  const currentRoute = JSON.parse(localStorage.getItem('currentRoute'))
  if(!currentRoute) return 
  if (new RegExp(currentRoute.regx).test(path)) return
  const routes = JSON.parse(sessionStorage.getItem('routes'))
  let res, modules = []
  routes.forEach((v) => {
    modules.push(...v.children)
  })
  modules.forEach(v => {
    // console.log(v)
    if (new RegExp(v.regx).test(path)) {
      res = v
    }
  })
  // console.log(res)
  res && localStorage.setItem('currentRoute', JSON.stringify(res.children))
  return res
}